import { render, staticRenderFns } from "./DungeonButtons.vue?vue&type=template&id=bf89f2d6&scoped=true"
import script from "./DungeonButtons.vue?vue&type=script&lang=js"
export * from "./DungeonButtons.vue?vue&type=script&lang=js"
import style0 from "./DungeonButtons.vue?vue&type=style&index=0&id=bf89f2d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf89f2d6",
  null
  
)

export default component.exports